import { h, Fragment, render } from "preact";
import { useEffect, useState } from "preact/hooks";
import { Typography, Tooltip } from "antd";
import { DeleteOutlined } from '@ant-design/icons';
import axios from "axios";
import useWebhooks from "./useWebhooks";

export default function WebhookDatasource(){
    const {webhooks} = useWebhooks();
    
    function asTableView() {
        return {
        columns: [
            {
                title: "Service name",
                dataIndex: "service_name",
                render: (service_name, index)=>(
                
                <Typography.Text>
                    {service_name}
                </Typography.Text>
                ),
                width: "30%",
            },
        ],
        rows:
            webhooks && Array.isArray(webhooks)
            ? webhooks.map((webhook, index) => ({
                key: index,
                service_name: webhook.service_name,
                target_url: webhook.target_url,
                }))
            : [],
        };
    }

    return { asTableView };

}